'use strict';

import {ngDepModel} from './ngdepmodel.js';

import {evlCriterionModel} from './evlcriterionmodel.js';
import {evlCriteriaGroupModel} from './evlcriteriagroupmodel.js';
import {evlFieldModel} from './evlfieldmodel.js';
import {br} from './br.js';

export class evlawrcriDataModel extends ngDepModel
{
	
	criteria = {};
	fields = {};
	wp_fields = {};
	wp_total_fields = {};
	budgetReduction;
	
	
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	beforeSetup(data){
		if(typeof(data.criteria) !== 'undefined'){
			for(let id in data.criteria){
				if(typeof(data.criteria[id].type) !== 'undefined' && data.criteria[id].type == 'group'){
					data.criteria[id] = new evlCriteriaGroupModel(data.criteria[id], this._services.$filter, this._services.jsDataService);
				}
				else{
					data.criteria[id] = new evlCriterionModel(data.criteria[id], this._services.$filter, this._services.jsDataService);
				}
			}
		}
		let fieldModelParams = ['fields', 'wp_fields', 'wp_total_fields'];
		for(let ff of fieldModelParams){
			if(typeof(data[ff]) !== 'undefined'){
				for(let id in data[ff]){
					data[ff][id] = new evlFieldModel(data[ff][id], this._services.$filter, this._services.jsDataService);
				}
			}
		}
		
		if(typeof(data.budgetReduction) !== 'undefined' && data.budgetReduction){
			data.budgetReduction = new br(data.budgetReduction);
		}
		else if(typeof(data.budget_reduction) !== 'undefined' && data.budget_reduction){
			data.budgetReduction = new br(data.budget_reduction);
		}
	}
	
	afterSetup(){
//		console.log(this.budgetReduction.getWpList());
		this.countTotal();
//		console.log(this.wp_fields.acronym.getValue('title'));
		if(typeof(this.budgetReduction) !== 'undefined' && this.budgetReduction instanceof br){
			this.projectGrantAmountProposed = this.budgetReduction.getProposed();
		}
	}
	
	countTotal(){
		this.total.threshold = 0;
		this.total.max = 0;
		this.total.score = 0;
//		console.log(this.criteria);
		for(let id in this.criteria){
			if(!this.criteria[id].hasParent){
				this.total.threshold += this.criteria[id].getThreshold();
				this.total.max += this.criteria[id].getMax();
				this.total.score += this.criteria[id].getScore();
			}
		}
	}
	
	getCriteriaList(){
		let items = [];
		for(let id in this.criteria){
			items.push(this.criteria[id]);
			if(this.criteria[id].type == 'group'){
				for(let cid in this.criteria[id].criteria){
					items.push(this.criteria[id].criteria[cid]);
				}
			}
		}
		return items;
	}
	
	getCriteriaData(){
		let obj = Object.assign({}, angular.copy(this.criteria));
		for(let id in obj){
			if(obj[id] instanceof evlCriterionModel || obj[id] instanceof evlCriteriaGroupModel){
				obj[id] = obj[id].getData();
			}
		}
		return obj;
	}

	getWpFieldsData(){
		let obj = Object.assign({}, angular.copy(this.wp_fields));
		for(let id in obj){
			if(obj[id] instanceof evlFieldModel){
				obj[id] = obj[id].getData();
			}
		}
		return obj;
	}
	
	getFieldsData(){
		let obj = Object.assign({}, angular.copy(this.fields));
		for(let id in obj){
			if(obj[id] instanceof evlFieldModel){
				obj[id] = obj[id].getData();
			}
		}
		return obj;
	}
	
	isTooLow(){
		return (this.total.score < this.total.fixedthreshold);
	}
	
	isTooHigh(){
		return (this.total.score > this.total.max);
	}
	
	isAnyTooHigh(){
		if(this.isTooHigh()){
			return true;
		}
		for(let id in this.criteria){
			if(this.criteria[id] instanceof evlCriteriaGroupModel){
				if(this.criteria[id].isAnyTooHigh()){
					return true;
				}
			}
			else if(this.criteria[id].isTooHigh()){
				return true;
			}
		}
		return false;
	}
	
	getScore(){
		this.countTotal();
		return Number(this.total.score.toFixed(2));
//		return parseInt(this.total.score);
	}

	getMax(){
		this.countTotal();
		return Number(this.total.max.toFixed(2));
	}

	getThreshold(){
		this.countTotal();
		return Number(this.total.threshold.toFixed(2));
	}
	
//	getWpFieldTitle(id){
//		if(typeof(this.wp_fields[id]) === 'undefined'){
//			return null;
//		}
//		return this.wp_fields[id].title;
//	}
	
//	getValue(name){
//		switch(name){
//			case 'applicationTime':
//				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
//			
//		}
//		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
//			return this[name];
//		}
//		return null;
//	}
//
//	getQuestion(id){
//		if(typeof(this.questions[id]) === 'undefined'){
//			return null;
//		}
//		return this.questions[id];
//	}
//	
//	isQInstruction(id){
//		let q = this.getQuestion(id);
//		if(!q){
//			return false;
//		}
//		if(!q.instruction || q.instruction === ''){
//			return false;
//		}
//		return true;
//	}
//	
//	getQuestionValue(id){
//		let q = this.getQuestion(id);
//		if(!q){
//			return null;
//		}
//		if(q.value === ''){
//			return '';
//		}
//		let classif = this.s('jsDataService').get('cfgClassif');
//		let classifName = 'yesnonot';
//		if(id == 'p1qf' || id == 'p2qf'){
//			classifName = 'yesno';
//		}
//		if(classif && typeof(classif[classifName]) !== 'undefined'){
//			let v = this.s('$filter')('filter')(classif[classifName], {id: q.value}, true);
//			if(v.length > 0){
//				return v[0].title;
//			}
//		}
//		return '';
//	}
	
}
